import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import MainLayout from '@components/layout/MainLayout';
import { ProtectedRoute } from '@components/layout/ProtectedRoute';
import { ToastProvider } from '@components/common/ToastManager';
import HomePage from '@pages/Home';
import LoginPage from '@pages/Login';
import VideoDetailPage from '@pages/VideoDetail';
import TopicSelectionPage from '@pages/TopicSelection';
import ScriptEditorPage from '@pages/ScriptEditor';
import CastingStudioPage from '@pages/CastingStudio';
import StoryboardDesignerPage from '@pages/StoryboardDesigner';
import VideoEditorPage from '@pages/VideoEditor';
import PublishPage from '@pages/Publish';
import MarketplacePage from '@pages/Marketplace';
import AssetDetailPage from '@pages/AssetDetail';
import SearchResultsPage from '@pages/SearchResults';
import ProfilePage from '@pages/Profile';
import ProjectsPage from '@pages/Projects';
import SettingsPage from '@pages/Settings';
import NotFound from '@pages/NotFound';
import AdminPage from '@pages/Admin';
import { logPageView } from '@services/logService';
// 页面访问日志记录组件
function PageLogger() {
    const location = useLocation();
    useEffect(() => {
        // 根据路径获取页面名称和来源
        const getPageInfo = (path) => {
            // 后台页面
            if (path === '/admin')
                return { name: '管理后台', source: '后台' };
            // 前台页面
            if (path === '/')
                return { name: '首页', source: '前台' };
            if (path === '/login')
                return { name: '登录页', source: '前台' };
            if (path === '/topics')
                return { name: '选题中心', source: '前台' };
            if (path === '/marketplace')
                return { name: '资源市场', source: '前台' };
            if (path === '/projects')
                return { name: '我的项目', source: '前台' };
            if (path === '/profile')
                return { name: '个人中心', source: '前台' };
            if (path === '/settings')
                return { name: '设置', source: '前台' };
            if (path === '/search')
                return { name: '搜索结果', source: '前台' };
            if (path.startsWith('/video/'))
                return { name: '作品详情', source: '前台' };
            if (path.startsWith('/asset/'))
                return { name: '资源详情', source: '前台' };
            if (path.includes('/script'))
                return { name: '剧本编辑', source: '前台' };
            if (path.includes('/casting'))
                return { name: '选角工作室', source: '前台' };
            if (path.includes('/storyboard'))
                return { name: '分镜设计', source: '前台' };
            if (path.includes('/editor'))
                return { name: '视频编辑', source: '前台' };
            if (path.includes('/publish'))
                return { name: '发布作品', source: '前台' };
            return { name: path, source: '前台' };
        };
        const pageInfo = getPageInfo(location.pathname);
        logPageView(pageInfo.name, pageInfo.source);
    }, [location.pathname]);
    return null;
}
function App() {
    return (_jsxs(ToastProvider, { children: [_jsx(PageLogger, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/admin", element: _jsx(AdminPage, {}) }), _jsx(Route, { path: "/project/:id/script", element: _jsx(ProtectedRoute, { children: _jsx(ScriptEditorPage, {}) }) }), _jsx(Route, { path: "/project/:id/editor", element: _jsx(ProtectedRoute, { children: _jsx(VideoEditorPage, {}) }) }), _jsxs(Route, { path: "/", element: _jsx(MainLayout, {}), children: [_jsx(Route, { index: true, element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/video/:id", element: _jsx(VideoDetailPage, {}) }), _jsx(Route, { path: "/topics", element: _jsx(ProtectedRoute, { children: _jsx(TopicSelectionPage, {}) }) }), _jsx(Route, { path: "/project/:id/casting", element: _jsx(ProtectedRoute, { children: _jsx(CastingStudioPage, {}) }) }), _jsx(Route, { path: "/project/:id/storyboard", element: _jsx(ProtectedRoute, { children: _jsx(StoryboardDesignerPage, {}) }) }), _jsx(Route, { path: "/project/:id/publish", element: _jsx(ProtectedRoute, { children: _jsx(PublishPage, {}) }) }), _jsx(Route, { path: "/marketplace", element: _jsx(MarketplacePage, {}) }), _jsx(Route, { path: "/marketplace/asset/:id", element: _jsx(AssetDetailPage, {}) }), _jsx(Route, { path: "/search", element: _jsx(SearchResultsPage, {}) }), _jsx(Route, { path: "/profile", element: _jsx(ProtectedRoute, { children: _jsx(ProfilePage, {}) }) }), _jsx(Route, { path: "/projects", element: _jsx(ProtectedRoute, { children: _jsx(ProjectsPage, {}) }) }), _jsx(Route, { path: "/settings", element: _jsx(ProtectedRoute, { children: _jsx(SettingsPage, {}) }) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] })] })] }));
}
export default App;
